import React from "react";
import { cn } from "@/lib/utils";

type ErrorMessageProps = {
  message: string;
  className?: string;
};

export const ErrorMessage = ({ message, className }: ErrorMessageProps) => {
  if (!message) return null;

  return (
    <div className={cn("text-destructive mt-1 text-xs", className)}>
      {message}
    </div>
  );
};
